
import { Component, Vue, Prop} from 'vue-property-decorator';

import Form19ProcessHeader from "@/components/process/Form19/components/Form19ProcessHeader.vue";
import { form19StatusInfoType } from '@/types/Information/Form19';

@Component({
    components:{
        Form19ProcessHeader
    }
})
export default class ErrorSubmitForm19 extends Vue {
    
    @Prop({required: true, default:" "})
    errMsg!: string;

    stepsCompleted = {} as form19StatusInfoType;  
    mountedData = false;     

    mounted() {
        this.mountedData = false;        

        this.stepsCompleted = {
            first: true,
            second: true,
            third: false,
            thirdError:true
        }
        this.mountedData = true;                   
    }    

    public done() {
        this.$router.push({name: "dashboard" }) 
    }

    public contactUs(){
        const ContactButton = document.getElementsByName("contact-us");
        if(ContactButton[0]) ContactButton[0].click()
    }
}
